import React from 'react';
import { X, Share2 } from 'lucide-react';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeModal = ({ isOpen, onClose, _t, avatarImage, userName, userId, onSimulateStranger: _onSimulateStranger }) => {
  if (!isOpen) return null;

  const qrData = JSON.stringify({
    type: 'openyc_user',
    userId: userId,
    userName: userName
  });

  const handleShare = async () => {
    const shareUrl = `${window.location.origin}/chat/${userId}`;
    try {
      await navigator.clipboard.writeText(shareUrl);
      alert('链接已复制到剪贴板');
    } catch (err) {
      console.error('复制失败:', err);
    }
  };

  return (
    <div className="absolute inset-0 z-[100] bg-black/80 backdrop-blur-xl flex items-center justify-center p-6 page-enter" onClick={onClose}>
      <div className="glass-card p-8 rounded-[40px] w-full max-w-sm flex flex-col items-center relative overflow-hidden shadow-2xl border-t border-white/20" onClick={e => e.stopPropagation()}>
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[var(--neon-primary)] to-transparent"></div>

        <div className="w-full flex justify-between items-center mb-6">
          <h2 className="text-lg font-bold text-white">我的分身二维码</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-full transition-colors">
            <X size={20} className="text-white/60" />
          </button>
        </div>

        <div className="w-24 h-24 rounded-full p-1 bg-gradient-to-tr from-[var(--neon-primary)] to-[var(--neon-secondary)] mb-4 shadow-[0_0_50px_rgba(0,242,234,0.3)]">
           <img src={avatarImage} alt="Avatar" className="w-full h-full object-cover rounded-full bg-black" />
        </div>
        <h3 className="text-xl font-bold text-white mb-1 glow-text-white">{userName}</h3>
        <p className="text-xs text-cyan-300 font-mono tracking-[0.2em] mb-6">扫描下方二维码添加我的分身</p>

        <div className="bg-white p-4 rounded-3xl mb-6 shadow-2xl">
          <QRCodeSVG
            value={qrData}
            size={200}
            level="H"
            includeMargin={true}
            bgColor="#ffffff"
            fgColor="#000000"
          />
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleShare}
            className="flex items-center gap-2 text-xs font-bold text-[var(--neon-primary)] border border-[var(--neon-primary)]/30 px-5 py-2.5 rounded-full hover:bg-[var(--neon-primary)]/10 transition-colors"
          >
            <Share2 size={14} />
            复制链接
          </button>
        </div>
      </div>
    </div>
  );
}

export default QRCodeModal;
